import * as React from 'react';

import { cn } from '@/lib/utils';
import { focusRingClassNames } from './utils';

function Input({ className, type, disableFlex, ...props }: React.ComponentProps<'input'> & { disableFlex?: boolean }) {
    return (
        <input
            type={type}
            data-slot="input"
            data-private
            className={cn(
                'file:text-foreground light:placeholder:text-gz-neutral-800 dark:placeholder:text-gz-neutral-100 selection:bg-primary selection:text-primary-foreground border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 font-sans font-normal text-[16px] shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
                disableFlex ? '' : 'flex',
                focusRingClassNames,
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                // Session replay records the field as a blank box, so typed values never reach it.
                'rr-block',
                className,
            )}
            {...props}
        />
    );
}

export { Input };
